'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _WidgetLocationStyles;

var _templateObject = _taggedTemplateLiteral(['\n    padding-left: 16px;\n    padding-right: 0;\n    left: 0;\n    right: inherit;\n  '], ['\n    padding-left: 16px;\n    padding-right: 0;\n    left: 0;\n    right: inherit;\n  ']),
    _templateObject2 = _taggedTemplateLiteral(['\n    padding-left: 0;\n    padding-right: 16px;\n    left: inherit;\n    right: 0;\n  '], ['\n    padding-left: 0;\n    padding-right: 16px;\n    left: inherit;\n    right: 0;\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n  &.inline {\n    height: 100%;\n    width: 100%;\n    padding: 0;\n  }\n  ', '\n'], ['\n  &.inline {\n    height: 100%;\n    width: 100%;\n    padding: 0;\n  }\n  ', '\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactDom = require('react-dom');

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _isHidden = require('conversations-visibility-tools/visibility/isHidden');

var _addVisibilityChangeListener = require('conversations-visibility-tools/visibility/addVisibilityChangeListener');

var _removeVisibilityChangeListener = require('conversations-visibility-tools/visibility/removeVisibilityChangeListener');

var _WidgetLocations = require('conversations-visitor-experience-components/visitor-widget/constants/WidgetLocations');

var _PostMessageTypes = require('../constants/PostMessageTypes');

var _AsyncPropTypeBanner = require('../code-splitting/components/AsyncPropTypeBanner');

var _AsyncPropTypeBanner2 = _interopRequireDefault(_AsyncPropTypeBanner);

var _buildWidgetData = require('../widget-data/operators/buildWidgetData');

var _ApplicationLayout = require('./ApplicationLayout');

var _ApplicationLayout2 = _interopRequireDefault(_ApplicationLayout);

var _CheckerContainer = require('../react-rhumb/containers/CheckerContainer');

var _CheckerContainer2 = _interopRequireDefault(_CheckerContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var WidgetLocationStyles = (_WidgetLocationStyles = {}, _defineProperty(_WidgetLocationStyles, _WidgetLocations.LEFT_ALIGNED, (0, _styledComponents.css)(_templateObject)), _defineProperty(_WidgetLocationStyles, _WidgetLocations.RIGHT_ALIGNED, (0, _styledComponents.css)(_templateObject2)), _WidgetLocationStyles);

var WidgetAppContainer = _styledComponents2.default.div.withConfig({
  displayName: 'Application__WidgetAppContainer'
})(_templateObject3, function (_ref) {
  var widgetLocation = _ref.widgetLocation;
  return WidgetLocationStyles[widgetLocation];
});

var Application = function (_React$Component) {
  _inherits(Application, _React$Component);

  function Application(props) {
    _classCallCheck(this, Application);

    var _this = _possibleConstructorReturn(this, (Application.__proto__ || Object.getPrototypeOf(Application)).call(this, props));

    _this.handleDragover = _this.handleDragover.bind(_this);
    _this.handleDrop = _this.handleDrop.bind(_this);
    _this.registerDragDropHandlers = _this.registerDragDropHandlers.bind(_this);
    _this.unregisterDragDropHandlers = _this.unregisterDragDropHandlers.bind(_this);
    _this.handleVisibilityChange = _this.handleVisibilityChange.bind(_this);
    _this.registerContainerRef = _this.registerContainerRef.bind(_this);
    _this.getIframeDimensions = _this.getIframeDimensions.bind(_this);
    _this.onIframeResize = _this.onIframeResize.bind(_this);
    _this.onOpenUpdate = _this.onOpenUpdate.bind(_this);
    _this.requestWidget = _this.requestWidget.bind(_this);
    _this.onBrowserWindowResize = _this.onBrowserWindowResize.bind(_this);
    _this.onScrollPercentageChange = _this.onScrollPercentageChange.bind(_this);
    _this.onExitIntent = _this.onExitIntent.bind(_this);
    _this.receiveMessage = _this.receiveMessage.bind(_this);
    _this.renderContent = _this.renderContent.bind(_this);

    _this.state = {
      // initially assume the browser is big enough to fit the whole widget
      // then shrink as needed after first paint
      browserWindowHeight: 1080
    };
    return _this;
  }

  _createClass(Application, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          speedCurveWidgetData = _props.speedCurveWidgetData,
          handleReceiveWidgetData = _props.handleReceiveWidgetData;

      if (speedCurveWidgetData) {
        handleReceiveWidgetData({ data: speedCurveWidgetData });
      } else {
        this.requestWidget();
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('message', this.receiveMessage, false);
      this.registerDragDropHandlers();
      this.onIframeResize();

      if ((0, _isHidden.isHidden)()) {
        this.props.setWindowVisible(false);
      }

      (0, _addVisibilityChangeListener.addVisibilityChangeListener)(this.handleVisibilityChange);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('message', this.receiveMessage);
      this.unregisterDragDropHandlers();

      (0, _removeVisibilityChangeListener.removeVisibilityChangeListener)(this.handleVisibilityChange);
    }
  }, {
    key: 'handleDragover',
    value: function handleDragover(event) {
      event.preventDefault();
    }
  }, {
    key: 'handleDrop',
    value: function handleDrop(event) {
      event.preventDefault();
    }
  }, {
    key: 'registerDragDropHandlers',
    value: function registerDragDropHandlers() {
      window.addEventListener('dragover', this.handleDragover);
      window.addEventListener('drop', this.handleDrop);
    }
  }, {
    key: 'unregisterDragDropHandlers',
    value: function unregisterDragDropHandlers() {
      window.removeEventListener('dragover', this.handleDragover);
      window.removeEventListener('drop', this.handleDrop);
    }
  }, {
    key: 'handleVisibilityChange',
    value: function handleVisibilityChange(_ref2) {
      var isVisible = _ref2.isVisible;

      this.props.setWindowVisible(isVisible);
    }
  }, {
    key: 'registerContainerRef',
    value: function registerContainerRef(element) {
      this.containerRef = element ? (0, _reactDom.findDOMNode)(element) : null;
    }
  }, {
    key: 'getIframeDimensions',
    value: function getIframeDimensions() {
      var dimensions = this.containerRef ? this.containerRef.getBoundingClientRect() : {};
      var width = dimensions.width,
          height = dimensions.height;


      return {
        width: width,
        height: height
      };
    }
  }, {
    key: 'onIframeResize',
    value: function onIframeResize(size) {
      this.props.handleIframeResize(size || this.getIframeDimensions());
    }
  }, {
    key: 'onOpenUpdate',
    value: function onOpenUpdate(isOpened) {
      this.props.toggleOpen(isOpened);
    }
  }, {
    key: 'requestWidget',
    value: function requestWidget() {
      this.props.handleRequestWidget();
    }
  }, {
    key: 'onBrowserWindowResize',
    value: function onBrowserWindowResize(data) {
      this.setState({
        browserWindowHeight: data.height,
        browserWindowWidth: data.width
      });
    }
  }, {
    key: 'onScrollPercentageChange',
    value: function onScrollPercentageChange(data) {
      this.props.handleScrollPercentageChange({
        scrollPercentage: data.scrollPercentage
      });
    }
  }, {
    key: 'onExitIntent',
    value: function onExitIntent() {
      this.props.handleExitIntent();
    }
  }, {
    key: 'receiveMessage',
    value: function receiveMessage(_ref3) {
      var rawData = _ref3.data;

      var parsedData = null;
      try {
        parsedData = JSON.parse(rawData);
      } catch (err) {
        // unparseable / unexpected message format
        return;
      }

      var _parsedData = parsedData,
          _parsedData$type = _parsedData.type,
          type = _parsedData$type === undefined ? null : _parsedData$type,
          _parsedData$data = _parsedData.data,
          data = _parsedData$data === undefined ? null : _parsedData$data;


      switch (type) {
        case _PostMessageTypes.PERF_ATTRIBUTES:
          {
            if (window.newrelic && window.newrelic.addPageAction && data.perfAttributes) {
              window.newrelic.addPageAction('embedScriptPerfAttributes', data.perfAttributes);
            }
            break;
          }
        case _PostMessageTypes.WIDGET_DATA:
          {
            this.props.handleReceiveWidgetData({ data: data });
            break;
          }
        case _PostMessageTypes.REFRESH_WIDGET_DATA:
          {
            this.props.refreshWidgetData((0, _buildWidgetData.buildWidgetData)(parsedData.data));
            break;
          }
        case _PostMessageTypes.REQUEST_OPEN:
          this.onOpenUpdate(true);
          break;
        case _PostMessageTypes.REQUEST_CLOSE:
          this.onOpenUpdate(false);
          break;
        case _PostMessageTypes.BROWSER_WINDOW_RESIZE:
          this.onBrowserWindowResize(data);
          break;
        case _PostMessageTypes.SCROLL_PERCENTAGE_CHANGE:
          this.onScrollPercentageChange(data);
          break;
        case _PostMessageTypes.EXIT_INTENT:
          this.onExitIntent();
          break;
        default:
          break;
      }
    }
  }, {
    key: 'renderContent',
    value: function renderContent() {
      var _props2 = this.props,
          inline = _props2.inline,
          isOpen = _props2.isOpen,
          mobile = _props2.mobile,
          onLauncherHover = _props2.onLauncherHover,
          toggleOpen = _props2.toggleOpen,
          trackUserInteraction = _props2.trackUserInteraction,
          widgetLocation = _props2.widgetLocation;


      return _react2.default.createElement(_ApplicationLayout2.default, {
        browserWindowHeight: this.state.browserWindowHeight,
        browserWindowWidth: this.state.browserWindowWidth,
        inline: inline,
        isOpen: isOpen,
        mobile: mobile,
        onLauncherHover: onLauncherHover,
        onIframeResize: this.onIframeResize,
        toggleOpen: toggleOpen,
        trackUserInteraction: trackUserInteraction,
        widgetLocation: widgetLocation
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var shouldRenderContent = this.props.shouldRenderContent;


      var classes = (0, _classNames2.default)('widget-app-container', {
        inline: this.props.inline
      });

      return _react2.default.createElement(
        WidgetAppContainer,
        {
          ref: this.registerContainerRef,
          className: classes,
          widgetLocation: this.props.widgetLocation
        },
        _react2.default.createElement(_CheckerContainer2.default, null),
        shouldRenderContent ? this.renderContent() : null,
        _react2.default.createElement(_AsyncPropTypeBanner2.default, null)
      );
    }
  }]);

  return Application;
}(_react2.default.Component);

Application.displayName = 'Application';

Application.propTypes = {
  handleExitIntent: _react.PropTypes.func.isRequired,
  handleIframeResize: _react.PropTypes.func.isRequired,
  handleReceiveWidgetData: _react.PropTypes.func.isRequired,
  handleRequestWidget: _react.PropTypes.func.isRequired,
  handleScrollPercentageChange: _react.PropTypes.func.isRequired,
  inline: _react.PropTypes.bool.isRequired,
  isOpen: _react.PropTypes.bool.isRequired,
  mobile: _react.PropTypes.bool.isRequired,
  onLauncherHover: _react.PropTypes.func.isRequired,
  refreshWidgetData: _react.PropTypes.func.isRequired,
  setWindowVisible: _react.PropTypes.func.isRequired,
  shouldRenderContent: _react.PropTypes.bool.isRequired,
  speedCurveWidgetData: _react.PropTypes.object,
  toggleOpen: _react.PropTypes.func.isRequired,
  trackUserInteraction: _react.PropTypes.func.isRequired,
  widgetLocation: _WidgetLocations.WidgetLocationProp
};

exports.default = Application;
module.exports = exports['default'];